/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as JoinRouteImport } from './routes/join'
import { Route as AuthenticatedProfileRouteRouteImport } from './routes/_authenticated/profile/route'
import { Route as AuthenticatedOrgOrgIdRouteRouteImport } from './routes/_authenticated/org/$orgId/route'
import { Route as AuthenticatedOrgOrgIdIndexRouteImport } from './routes/_authenticated/org/$orgId/index'
import { Route as AuthenticatedOrgOrgIdEditIndexRouteImport } from './routes/_authenticated/org/$orgId/edit/index'
import { Route as AuthenticatedOrgOrgIdMembersIndexRouteImport } from './routes/_authenticated/org/$orgId/members/index'
import { Route as AuthenticatedOrgOrgIdProgramIndexRouteImport } from './routes/_authenticated/org/$orgId/program/index'
import { Route as AuthenticatedOrgOrgIdProgramProgramIdRouteRouteImport } from './routes/_authenticated/org/$orgId/program/$programId/route'
import { Route as AuthenticatedOrgOrgIdReferralsIndexRouteImport } from './routes/_authenticated/org/$orgId/referrals/index'
import { Route as AuthenticatedOrgOrgIdProgramProgramIdIndexRouteImport } from './routes/_authenticated/org/$orgId/program/$programId/index'
import { Route as AuthenticatedOrgOrgIdProgramCreateIndexRouteImport } from './routes/_authenticated/org/$orgId/program/create/index'
import { Route as AuthenticatedOrgOrgIdProgramProgramIdApplicantsIndexRouteImport } from './routes/_authenticated/org/$orgId/program/$programId/applicants/index'
import { Route as AuthenticatedOrgOrgIdProgramProgramIdEditIndexRouteImport } from './routes/_authenticated/org/$orgId/program/$programId/edit/index'
import { Route as AuthenticatedOrgOrgIdProgramProgramIdQuestionsIndexRouteImport } from './routes/_authenticated/org/$orgId/program/$programId/questions/index'
import { Route as AuthenticatedOrgOrgIdProgramProgramIdRevisionsIndexRouteImport } from './routes/_authenticated/org/$orgId/program/$programId/revisions/index'

const QrLazyRouteImport = createFileRoute('/qr')()
const AuthIndexLazyRouteImport = createFileRoute('/_auth/')()
const AuthRegisterOrgLazyRouteImport = createFileRoute('/_auth/register/org')()
const AuthRegisterPlanLazyRouteImport = createFileRoute(
  '/_auth/register/plan',
)()
const AuthenticatedProfileIndexLazyRouteImport = createFileRoute(
  '/_authenticated/profile/',
)()
const AuthenticatedProfileWalletLazyRouteImport = createFileRoute(
  '/_authenticated/profile/wallet',
)()
const AuthenticatedOrgCreateIndexLazyRouteImport = createFileRoute(
  '/_authenticated/org/create/',
)()

const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinRoute = JoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/join.lazy').then((d) => d.Route))
const QrLazyRoute = QrLazyRouteImport.update({
  id: '/qr',
  path: '/qr',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/qr.lazy').then((d) => d.Route))
const AuthIndexLazyRoute = AuthIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() => import('./routes/_auth/index.lazy').then((d) => d.Route))
const AuthenticatedProfileRouteRoute =
  AuthenticatedProfileRouteRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthRegisterOrgLazyRoute = AuthRegisterOrgLazyRouteImport.update({
  id: '/register/org',
  path: '/register/org',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/register/org.lazy').then((d) => d.Route),
)
const AuthRegisterPlanLazyRoute = AuthRegisterPlanLazyRouteImport.update({
  id: '/register/plan',
  path: '/register/plan',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/register/plan.lazy').then((d) => d.Route),
)
const AuthenticatedOrgOrgIdRouteRoute =
  AuthenticatedOrgOrgIdRouteRouteImport.update({
    id: '/org/$orgId',
    path: '/org/$orgId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProfileIndexLazyRoute =
  AuthenticatedProfileIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedProfileRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/profile/index.lazy').then((d) => d.Route),
  )
const AuthenticatedProfileWalletLazyRoute =
  AuthenticatedProfileWalletLazyRouteImport.update({
    id: '/wallet',
    path: '/wallet',
    getParentRoute: () => AuthenticatedProfileRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/profile/wallet.lazy').then((d) => d.Route),
  )
const AuthenticatedOrgOrgIdIndexRoute =
  AuthenticatedOrgOrgIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgOrgIdRouteRoute,
  } as any)
const AuthenticatedOrgCreateIndexLazyRoute =
  AuthenticatedOrgCreateIndexLazyRouteImport.update({
    id: '/org/create/',
    path: '/org/create/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/org/create/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedOrgOrgIdEditIndexRoute =
  AuthenticatedOrgOrgIdEditIndexRouteImport.update({
    id: '/edit/',
    path: '/edit/',
    getParentRoute: () => AuthenticatedOrgOrgIdRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdMembersIndexRoute =
  AuthenticatedOrgOrgIdMembersIndexRouteImport.update({
    id: '/members/',
    path: '/members/',
    getParentRoute: () => AuthenticatedOrgOrgIdRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdProgramIndexRoute =
  AuthenticatedOrgOrgIdProgramIndexRouteImport.update({
    id: '/program/',
    path: '/program/',
    getParentRoute: () => AuthenticatedOrgOrgIdRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdProgramProgramIdRouteRoute =
  AuthenticatedOrgOrgIdProgramProgramIdRouteRouteImport.update({
    id: '/program/$programId',
    path: '/program/$programId',
    getParentRoute: () => AuthenticatedOrgOrgIdRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdReferralsIndexRoute =
  AuthenticatedOrgOrgIdReferralsIndexRouteImport.update({
    id: '/referrals/',
    path: '/referrals/',
    getParentRoute: () => AuthenticatedOrgOrgIdRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdProgramProgramIdIndexRoute =
  AuthenticatedOrgOrgIdProgramProgramIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgOrgIdProgramProgramIdRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdProgramCreateIndexRoute =
  AuthenticatedOrgOrgIdProgramCreateIndexRouteImport.update({
    id: '/program/create/',
    path: '/program/create/',
    getParentRoute: () => AuthenticatedOrgOrgIdRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdProgramProgramIdApplicantsIndexRoute =
  AuthenticatedOrgOrgIdProgramProgramIdApplicantsIndexRouteImport.update({
    id: '/applicants/',
    path: '/applicants/',
    getParentRoute: () => AuthenticatedOrgOrgIdProgramProgramIdRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdProgramProgramIdEditIndexRoute =
  AuthenticatedOrgOrgIdProgramProgramIdEditIndexRouteImport.update({
    id: '/edit/',
    path: '/edit/',
    getParentRoute: () => AuthenticatedOrgOrgIdProgramProgramIdRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdProgramProgramIdQuestionsIndexRoute =
  AuthenticatedOrgOrgIdProgramProgramIdQuestionsIndexRouteImport.update({
    id: '/questions/',
    path: '/questions/',
    getParentRoute: () => AuthenticatedOrgOrgIdProgramProgramIdRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdProgramProgramIdRevisionsIndexRoute =
  AuthenticatedOrgOrgIdProgramProgramIdRevisionsIndexRouteImport.update({
    id: '/revisions/',
    path: '/revisions/',
    getParentRoute: () => AuthenticatedOrgOrgIdProgramProgramIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexLazyRoute
  '/join': typeof JoinRoute
  '/qr': typeof QrLazyRoute
  '/profile': typeof AuthenticatedProfileRouteRouteWithChildren
  '/org/$orgId': typeof AuthenticatedOrgOrgIdRouteRouteWithChildren
  '/register/org': typeof AuthRegisterOrgLazyRoute
  '/register/plan': typeof AuthRegisterPlanLazyRoute
  '/profile/wallet': typeof AuthenticatedProfileWalletLazyRoute
  '/profile/': typeof AuthenticatedProfileIndexLazyRoute
  '/org/$orgId/': typeof AuthenticatedOrgOrgIdIndexRoute
  '/org/create/': typeof AuthenticatedOrgCreateIndexLazyRoute
  '/org/$orgId/program/$programId': typeof AuthenticatedOrgOrgIdProgramProgramIdRouteRouteWithChildren
  '/org/$orgId/edit/': typeof AuthenticatedOrgOrgIdEditIndexRoute
  '/org/$orgId/members/': typeof AuthenticatedOrgOrgIdMembersIndexRoute
  '/org/$orgId/program/': typeof AuthenticatedOrgOrgIdProgramIndexRoute
  '/org/$orgId/referrals/': typeof AuthenticatedOrgOrgIdReferralsIndexRoute
  '/org/$orgId/program/$programId/': typeof AuthenticatedOrgOrgIdProgramProgramIdIndexRoute
  '/org/$orgId/program/create/': typeof AuthenticatedOrgOrgIdProgramCreateIndexRoute
  '/org/$orgId/program/$programId/applicants/': typeof AuthenticatedOrgOrgIdProgramProgramIdApplicantsIndexRoute
  '/org/$orgId/program/$programId/edit/': typeof AuthenticatedOrgOrgIdProgramProgramIdEditIndexRoute
  '/org/$orgId/program/$programId/questions/': typeof AuthenticatedOrgOrgIdProgramProgramIdQuestionsIndexRoute
  '/org/$orgId/program/$programId/revisions/': typeof AuthenticatedOrgOrgIdProgramProgramIdRevisionsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthIndexLazyRoute
  '/join': typeof JoinRoute
  '/qr': typeof QrLazyRoute
  '/register/org': typeof AuthRegisterOrgLazyRoute
  '/register/plan': typeof AuthRegisterPlanLazyRoute
  '/profile/wallet': typeof AuthenticatedProfileWalletLazyRoute
  '/profile': typeof AuthenticatedProfileIndexLazyRoute
  '/org/$orgId': typeof AuthenticatedOrgOrgIdIndexRoute
  '/org/create': typeof AuthenticatedOrgCreateIndexLazyRoute
  '/org/$orgId/edit': typeof AuthenticatedOrgOrgIdEditIndexRoute
  '/org/$orgId/members': typeof AuthenticatedOrgOrgIdMembersIndexRoute
  '/org/$orgId/program': typeof AuthenticatedOrgOrgIdProgramIndexRoute
  '/org/$orgId/referrals': typeof AuthenticatedOrgOrgIdReferralsIndexRoute
  '/org/$orgId/program/$programId': typeof AuthenticatedOrgOrgIdProgramProgramIdIndexRoute
  '/org/$orgId/program/create': typeof AuthenticatedOrgOrgIdProgramCreateIndexRoute
  '/org/$orgId/program/$programId/applicants': typeof AuthenticatedOrgOrgIdProgramProgramIdApplicantsIndexRoute
  '/org/$orgId/program/$programId/edit': typeof AuthenticatedOrgOrgIdProgramProgramIdEditIndexRoute
  '/org/$orgId/program/$programId/questions': typeof AuthenticatedOrgOrgIdProgramProgramIdQuestionsIndexRoute
  '/org/$orgId/program/$programId/revisions': typeof AuthenticatedOrgOrgIdProgramProgramIdRevisionsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/join': typeof JoinRoute
  '/qr': typeof QrLazyRoute
  '/_authenticated/profile': typeof AuthenticatedProfileRouteRouteWithChildren
  '/_auth/': typeof AuthIndexLazyRoute
  '/_authenticated/org/$orgId': typeof AuthenticatedOrgOrgIdRouteRouteWithChildren
  '/_auth/register/org': typeof AuthRegisterOrgLazyRoute
  '/_auth/register/plan': typeof AuthRegisterPlanLazyRoute
  '/_authenticated/profile/wallet': typeof AuthenticatedProfileWalletLazyRoute
  '/_authenticated/profile/': typeof AuthenticatedProfileIndexLazyRoute
  '/_authenticated/org/$orgId/': typeof AuthenticatedOrgOrgIdIndexRoute
  '/_authenticated/org/create/': typeof AuthenticatedOrgCreateIndexLazyRoute
  '/_authenticated/org/$orgId/program/$programId': typeof AuthenticatedOrgOrgIdProgramProgramIdRouteRouteWithChildren
  '/_authenticated/org/$orgId/edit/': typeof AuthenticatedOrgOrgIdEditIndexRoute
  '/_authenticated/org/$orgId/members/': typeof AuthenticatedOrgOrgIdMembersIndexRoute
  '/_authenticated/org/$orgId/program/': typeof AuthenticatedOrgOrgIdProgramIndexRoute
  '/_authenticated/org/$orgId/referrals/': typeof AuthenticatedOrgOrgIdReferralsIndexRoute
  '/_authenticated/org/$orgId/program/$programId/': typeof AuthenticatedOrgOrgIdProgramProgramIdIndexRoute
  '/_authenticated/org/$orgId/program/create/': typeof AuthenticatedOrgOrgIdProgramCreateIndexRoute
  '/_authenticated/org/$orgId/program/$programId/applicants/': typeof AuthenticatedOrgOrgIdProgramProgramIdApplicantsIndexRoute
  '/_authenticated/org/$orgId/program/$programId/edit/': typeof AuthenticatedOrgOrgIdProgramProgramIdEditIndexRoute
  '/_authenticated/org/$orgId/program/$programId/questions/': typeof AuthenticatedOrgOrgIdProgramProgramIdQuestionsIndexRoute
  '/_authenticated/org/$orgId/program/$programId/revisions/': typeof AuthenticatedOrgOrgIdProgramProgramIdRevisionsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/join'
    | '/qr'
    | '/profile'
    | '/org/$orgId'
    | '/register/org'
    | '/register/plan'
    | '/profile/wallet'
    | '/profile/'
    | '/org/$orgId/'
    | '/org/create/'
    | '/org/$orgId/program/$programId'
    | '/org/$orgId/edit/'
    | '/org/$orgId/members/'
    | '/org/$orgId/program/'
    | '/org/$orgId/referrals/'
    | '/org/$orgId/program/$programId/'
    | '/org/$orgId/program/create/'
    | '/org/$orgId/program/$programId/applicants/'
    | '/org/$orgId/program/$programId/edit/'
    | '/org/$orgId/program/$programId/questions/'
    | '/org/$orgId/program/$programId/revisions/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/join'
    | '/qr'
    | '/register/org'
    | '/register/plan'
    | '/profile/wallet'
    | '/profile'
    | '/org/$orgId'
    | '/org/create'
    | '/org/$orgId/edit'
    | '/org/$orgId/members'
    | '/org/$orgId/program'
    | '/org/$orgId/referrals'
    | '/org/$orgId/program/$programId'
    | '/org/$orgId/program/create'
    | '/org/$orgId/program/$programId/applicants'
    | '/org/$orgId/program/$programId/edit'
    | '/org/$orgId/program/$programId/questions'
    | '/org/$orgId/program/$programId/revisions'
  id:
    | '__root__'
    | '/_auth'
    | '/_authenticated'
    | '/join'
    | '/qr'
    | '/_authenticated/profile'
    | '/_auth/'
    | '/_authenticated/org/$orgId'
    | '/_auth/register/org'
    | '/_auth/register/plan'
    | '/_authenticated/profile/wallet'
    | '/_authenticated/profile/'
    | '/_authenticated/org/$orgId/'
    | '/_authenticated/org/create/'
    | '/_authenticated/org/$orgId/program/$programId'
    | '/_authenticated/org/$orgId/edit/'
    | '/_authenticated/org/$orgId/members/'
    | '/_authenticated/org/$orgId/program/'
    | '/_authenticated/org/$orgId/referrals/'
    | '/_authenticated/org/$orgId/program/$programId/'
    | '/_authenticated/org/$orgId/program/create/'
    | '/_authenticated/org/$orgId/program/$programId/applicants/'
    | '/_authenticated/org/$orgId/program/$programId/edit/'
    | '/_authenticated/org/$orgId/program/$programId/questions/'
    | '/_authenticated/org/$orgId/program/$programId/revisions/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  JoinRoute: typeof JoinRoute
  QrLazyRoute: typeof QrLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join': {
      id: '/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof JoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/qr': {
      id: '/qr'
      path: '/qr'
      fullPath: '/qr'
      preLoaderRoute: typeof QrLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_auth/register/org': {
      id: '/_auth/register/org'
      path: '/register/org'
      fullPath: '/register/org'
      preLoaderRoute: typeof AuthRegisterOrgLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/register/plan': {
      id: '/_auth/register/plan'
      path: '/register/plan'
      fullPath: '/register/plan'
      preLoaderRoute: typeof AuthRegisterPlanLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_authenticated/org/$orgId': {
      id: '/_authenticated/org/$orgId'
      path: '/org/$orgId'
      fullPath: '/org/$orgId'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/profile/': {
      id: '/_authenticated/profile/'
      path: '/'
      fullPath: '/profile/'
      preLoaderRoute: typeof AuthenticatedProfileIndexLazyRouteImport
      parentRoute: typeof AuthenticatedProfileRouteRoute
    }
    '/_authenticated/profile/wallet': {
      id: '/_authenticated/profile/wallet'
      path: '/wallet'
      fullPath: '/profile/wallet'
      preLoaderRoute: typeof AuthenticatedProfileWalletLazyRouteImport
      parentRoute: typeof AuthenticatedProfileRouteRoute
    }
    '/_authenticated/org/$orgId/': {
      id: '/_authenticated/org/$orgId/'
      path: '/'
      fullPath: '/org/$orgId/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRouteRoute
    }
    '/_authenticated/org/create/': {
      id: '/_authenticated/org/create/'
      path: '/org/create'
      fullPath: '/org/create/'
      preLoaderRoute: typeof AuthenticatedOrgCreateIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/org/$orgId/edit/': {
      id: '/_authenticated/org/$orgId/edit/'
      path: '/edit'
      fullPath: '/org/$orgId/edit/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdEditIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRouteRoute
    }
    '/_authenticated/org/$orgId/members/': {
      id: '/_authenticated/org/$orgId/members/'
      path: '/members'
      fullPath: '/org/$orgId/members/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdMembersIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRouteRoute
    }
    '/_authenticated/org/$orgId/program/': {
      id: '/_authenticated/org/$orgId/program/'
      path: '/program'
      fullPath: '/org/$orgId/program/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdProgramIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRouteRoute
    }
    '/_authenticated/org/$orgId/program/$programId': {
      id: '/_authenticated/org/$orgId/program/$programId'
      path: '/program/$programId'
      fullPath: '/org/$orgId/program/$programId'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdProgramProgramIdRouteRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRouteRoute
    }
    '/_authenticated/org/$orgId/referrals/': {
      id: '/_authenticated/org/$orgId/referrals/'
      path: '/referrals'
      fullPath: '/org/$orgId/referrals/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdReferralsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRouteRoute
    }
    '/_authenticated/org/$orgId/program/$programId/': {
      id: '/_authenticated/org/$orgId/program/$programId/'
      path: '/'
      fullPath: '/org/$orgId/program/$programId/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdProgramProgramIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdProgramProgramIdRouteRoute
    }
    '/_authenticated/org/$orgId/program/create/': {
      id: '/_authenticated/org/$orgId/program/create/'
      path: '/program/create'
      fullPath: '/org/$orgId/program/create/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdProgramCreateIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRouteRoute
    }
    '/_authenticated/org/$orgId/program/$programId/applicants/': {
      id: '/_authenticated/org/$orgId/program/$programId/applicants/'
      path: '/applicants'
      fullPath: '/org/$orgId/program/$programId/applicants/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdProgramProgramIdApplicantsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdProgramProgramIdRouteRoute
    }
    '/_authenticated/org/$orgId/program/$programId/edit/': {
      id: '/_authenticated/org/$orgId/program/$programId/edit/'
      path: '/edit'
      fullPath: '/org/$orgId/program/$programId/edit/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdProgramProgramIdEditIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdProgramProgramIdRouteRoute
    }
    '/_authenticated/org/$orgId/program/$programId/questions/': {
      id: '/_authenticated/org/$orgId/program/$programId/questions/'
      path: '/questions'
      fullPath: '/org/$orgId/program/$programId/questions/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdProgramProgramIdQuestionsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdProgramProgramIdRouteRoute
    }
    '/_authenticated/org/$orgId/program/$programId/revisions/': {
      id: '/_authenticated/org/$orgId/program/$programId/revisions/'
      path: '/revisions'
      fullPath: '/org/$orgId/program/$programId/revisions/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdProgramProgramIdRevisionsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdProgramProgramIdRouteRoute
    }
  }
}

interface AuthRouteRouteChildren {
  AuthIndexLazyRoute: typeof AuthIndexLazyRoute
  AuthRegisterOrgLazyRoute: typeof AuthRegisterOrgLazyRoute
  AuthRegisterPlanLazyRoute: typeof AuthRegisterPlanLazyRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthIndexLazyRoute: AuthIndexLazyRoute,
  AuthRegisterOrgLazyRoute: AuthRegisterOrgLazyRoute,
  AuthRegisterPlanLazyRoute: AuthRegisterPlanLazyRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface AuthenticatedProfileRouteRouteChildren {
  AuthenticatedProfileWalletLazyRoute: typeof AuthenticatedProfileWalletLazyRoute
  AuthenticatedProfileIndexLazyRoute: typeof AuthenticatedProfileIndexLazyRoute
}

const AuthenticatedProfileRouteRouteChildren: AuthenticatedProfileRouteRouteChildren =
  {
    AuthenticatedProfileWalletLazyRoute: AuthenticatedProfileWalletLazyRoute,
    AuthenticatedProfileIndexLazyRoute: AuthenticatedProfileIndexLazyRoute,
  }

const AuthenticatedProfileRouteRouteWithChildren =
  AuthenticatedProfileRouteRoute._addFileChildren(
    AuthenticatedProfileRouteRouteChildren,
  )

interface AuthenticatedOrgOrgIdProgramProgramIdRouteRouteChildren {
  AuthenticatedOrgOrgIdProgramProgramIdIndexRoute: typeof AuthenticatedOrgOrgIdProgramProgramIdIndexRoute
  AuthenticatedOrgOrgIdProgramProgramIdApplicantsIndexRoute: typeof AuthenticatedOrgOrgIdProgramProgramIdApplicantsIndexRoute
  AuthenticatedOrgOrgIdProgramProgramIdEditIndexRoute: typeof AuthenticatedOrgOrgIdProgramProgramIdEditIndexRoute
  AuthenticatedOrgOrgIdProgramProgramIdQuestionsIndexRoute: typeof AuthenticatedOrgOrgIdProgramProgramIdQuestionsIndexRoute
  AuthenticatedOrgOrgIdProgramProgramIdRevisionsIndexRoute: typeof AuthenticatedOrgOrgIdProgramProgramIdRevisionsIndexRoute
}

const AuthenticatedOrgOrgIdProgramProgramIdRouteRouteChildren: AuthenticatedOrgOrgIdProgramProgramIdRouteRouteChildren =
  {
    AuthenticatedOrgOrgIdProgramProgramIdIndexRoute:
      AuthenticatedOrgOrgIdProgramProgramIdIndexRoute,
    AuthenticatedOrgOrgIdProgramProgramIdApplicantsIndexRoute:
      AuthenticatedOrgOrgIdProgramProgramIdApplicantsIndexRoute,
    AuthenticatedOrgOrgIdProgramProgramIdEditIndexRoute:
      AuthenticatedOrgOrgIdProgramProgramIdEditIndexRoute,
    AuthenticatedOrgOrgIdProgramProgramIdQuestionsIndexRoute:
      AuthenticatedOrgOrgIdProgramProgramIdQuestionsIndexRoute,
    AuthenticatedOrgOrgIdProgramProgramIdRevisionsIndexRoute:
      AuthenticatedOrgOrgIdProgramProgramIdRevisionsIndexRoute,
  }

const AuthenticatedOrgOrgIdProgramProgramIdRouteRouteWithChildren =
  AuthenticatedOrgOrgIdProgramProgramIdRouteRoute._addFileChildren(
    AuthenticatedOrgOrgIdProgramProgramIdRouteRouteChildren,
  )

interface AuthenticatedOrgOrgIdRouteRouteChildren {
  AuthenticatedOrgOrgIdIndexRoute: typeof AuthenticatedOrgOrgIdIndexRoute
  AuthenticatedOrgOrgIdProgramProgramIdRouteRoute: typeof AuthenticatedOrgOrgIdProgramProgramIdRouteRouteWithChildren
  AuthenticatedOrgOrgIdEditIndexRoute: typeof AuthenticatedOrgOrgIdEditIndexRoute
  AuthenticatedOrgOrgIdMembersIndexRoute: typeof AuthenticatedOrgOrgIdMembersIndexRoute
  AuthenticatedOrgOrgIdProgramIndexRoute: typeof AuthenticatedOrgOrgIdProgramIndexRoute
  AuthenticatedOrgOrgIdReferralsIndexRoute: typeof AuthenticatedOrgOrgIdReferralsIndexRoute
  AuthenticatedOrgOrgIdProgramCreateIndexRoute: typeof AuthenticatedOrgOrgIdProgramCreateIndexRoute
}

const AuthenticatedOrgOrgIdRouteRouteChildren: AuthenticatedOrgOrgIdRouteRouteChildren =
  {
    AuthenticatedOrgOrgIdIndexRoute: AuthenticatedOrgOrgIdIndexRoute,
    AuthenticatedOrgOrgIdProgramProgramIdRouteRoute:
      AuthenticatedOrgOrgIdProgramProgramIdRouteRouteWithChildren,
    AuthenticatedOrgOrgIdEditIndexRoute: AuthenticatedOrgOrgIdEditIndexRoute,
    AuthenticatedOrgOrgIdMembersIndexRoute:
      AuthenticatedOrgOrgIdMembersIndexRoute,
    AuthenticatedOrgOrgIdProgramIndexRoute:
      AuthenticatedOrgOrgIdProgramIndexRoute,
    AuthenticatedOrgOrgIdReferralsIndexRoute:
      AuthenticatedOrgOrgIdReferralsIndexRoute,
    AuthenticatedOrgOrgIdProgramCreateIndexRoute:
      AuthenticatedOrgOrgIdProgramCreateIndexRoute,
  }

const AuthenticatedOrgOrgIdRouteRouteWithChildren =
  AuthenticatedOrgOrgIdRouteRoute._addFileChildren(
    AuthenticatedOrgOrgIdRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedProfileRouteRoute: typeof AuthenticatedProfileRouteRouteWithChildren
  AuthenticatedOrgOrgIdRouteRoute: typeof AuthenticatedOrgOrgIdRouteRouteWithChildren
  AuthenticatedOrgCreateIndexLazyRoute: typeof AuthenticatedOrgCreateIndexLazyRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedProfileRouteRoute: AuthenticatedProfileRouteRouteWithChildren,
  AuthenticatedOrgOrgIdRouteRoute: AuthenticatedOrgOrgIdRouteRouteWithChildren,
  AuthenticatedOrgCreateIndexLazyRoute: AuthenticatedOrgCreateIndexLazyRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRouteRoute: AuthRouteRouteWithChildren,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  JoinRoute: JoinRoute,
  QrLazyRoute: QrLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
